function adjustTabbyTamaraPrices() {
    var priceElement = document.querySelector('.transcy-money');
    var qtyElement = document.querySelector('input[name="quantity"]');

    if (!priceElement || !qtyElement) {
        console.error("Price or Quantity input not found");
        return;
    }

    // Extract the price (removing non-numeric characters)
    var priceText = priceElement.innerText.replace(/[^0-9.]/g, ''); // Removes AED and any special characters
    var pPrice = parseFloat(priceText);

    var qty = parseInt(qtyElement.value);

    if (isNaN(pPrice) || isNaN(qty) || qty <= 0) {
        console.error("Invalid price or quantity");
        return;
    }

    var finalPrice = pPrice * qty;
    var installmentPrice = (finalPrice / 4).toFixed(2); // 4-installments calculation

    // Update the installment price
    var tabbyPriceElement = document.querySelector('.tabbyprices');
    if (tabbyPriceElement) {
        tabbyPriceElement.innerText = `AED ${installmentPrice}`;
    } else {
        console.error("Tabby price element not found");
    }

  
}

function observeVariantChange() {
    var variantInput = document.querySelector('input[name="id"]');
    
    if (!variantInput) {
        console.error("Variant input not found");
        return;
    }

    // Create a MutationObserver to track changes
    var observer = new MutationObserver(() => {
      //  console.log("Variant changed! Recalculating prices...");
        adjustTabbyTamaraPrices();
                updateEstimatedDeliveryDiv();

    });

    // Start observing changes to the "value" attribute
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
}

function updateEstimatedDeliveryDiv(retryCount = 0) {
  const variantInput = document.querySelector('input[name="id"]');
  const deliveryDiv = document.querySelector('.estimated_delivery');
  const deliveryDivMain = document.querySelector('.estimated_delivery_main');
  const deliveryIcon = document.querySelector('.estimated-deliver-icon');
  const deliveryStaticText = document.querySelector('.estimated-delivery-static-text');

  if (!variantInput) return;
  if (!deliveryDiv) {
    if (retryCount < 10) {
      setTimeout(() => updateEstimatedDeliveryDiv(retryCount + 1), 300);
    }
    return;
  }

  const selectedId = variantInput.value;
  const variant = window.bcpo_product_main?.variants.find(v => v.id == selectedId);
  const hideEstimated = window.bcpo_product_main?.hide_estimated_delivery;
  const customText = window.bcpo_product_main?.cust_delivery;

  if (!variant) {
    deliveryDiv.innerHTML = '';
    deliveryDivMain.style.display = 'none';
    return;
  }

  let displayText = '';
  let showingCustomText = false; // track if custom text is being shown

  if (hideEstimated) {
    // TRUE = manual/textbox mode
    if (customText && customText.trim() !== '') {
      displayText = customText;
      showingCustomText = true;
    } else {
      displayText = '';
    }
  } else {
    // FALSE = automated mode
    if (variant.estimated_delivery_date && variant.estimated_delivery_date.trim() !== '') {
      displayText = variant.estimated_delivery_date;
    } else {
      // fallback to default
      displayText = calculateEstimatedDelivery(
        window.bcpo_product_main.variants[0].estimated_days,
        window.bcpo_product_main.variants[0].cut_off_time
      );
    }
  }

  // --- Display logic ---
  if (displayText && displayText.trim() !== '') {
    deliveryDiv.innerHTML = displayText;
    deliveryDivMain.style.display = 'flex';

    // Handle icon + static text visibility
    if (showingCustomText) {
      if (deliveryIcon) deliveryIcon.style.display = 'none';
      if (deliveryStaticText) deliveryStaticText.style.display = 'none';
    } else {
      if (deliveryIcon) deliveryIcon.style.display = 'inline-block';
      if (deliveryStaticText) deliveryStaticText.style.display = 'inline-block';
    }

  } else {
    deliveryDiv.innerHTML = '';
    deliveryDivMain.style.display = 'none';
    // Also hide icons if no content
    if (deliveryIcon) deliveryIcon.style.display = 'none';
    if (deliveryStaticText) deliveryStaticText.style.display = 'none';
  }
}




function setupQuantityListener() {
    var qtyElement = document.querySelector('input[name="quantity"]');

    if (!qtyElement) {
        console.error("Quantity input not found");
        return;
    }
updateEstimatedDeliveryDiv();
    // Remove existing listeners to prevent duplicates
    qtyElement.removeEventListener('input', adjustTabbyTamaraPrices);
    qtyElement.removeEventListener('change', adjustTabbyTamaraPrices);

    // Listen for direct input changes
    qtyElement.addEventListener('input', adjustTabbyTamaraPrices);
    qtyElement.addEventListener('change', adjustTabbyTamaraPrices);

    // Detect clicks on quantity buttons (+ and -)
    document.querySelectorAll('.quantity-button').forEach(button => {
        button.removeEventListener('click', adjustTabbyTamaraPrices);
        button.addEventListener('click', function () {
            setTimeout(adjustTabbyTamaraPrices, 100); // Delay ensures correct value update
        });
    });

    // Use a MutationObserver to detect changes in the quantity field's value
    var observer = new MutationObserver(() => adjustTabbyTamaraPrices());
    observer.observe(qtyElement, { attributes: true, attributeFilter: ['value'] });

    //console.log("Quantity listener set up successfully");
}

// Ensure the listener is added when the page loads
document.addEventListener("DOMContentLoaded", setupQuantityListener);














// Run only if URL contains "/products/"
if (window.location.pathname.includes('/products/')) {
    setTimeout(() => {
        adjustTabbyTamaraPrices();  // Initial call after 2 seconds
        setupQuantityListener();    // Setup event listener
      observeVariantChange(); // Watch for variant changes
    }, 1500);
}


var form = document.querySelector("#product-form-template--17594084950196__main-product");

if (form) {
    form.addEventListener("submit", function (e) {
        var deliveryDiv = document.querySelector('.estimated_delivery');
        var variantInput = document.querySelector('input[name="id"]');

        if (!deliveryDiv || !variantInput) {
            return;
        }

        var selectedId = variantInput.value;
        var variant = window.bcpo_product_main.variants.find(v => v.id == selectedId);

        if (!variant) {
            return;
        }

        // Remove old hidden input if it exists
        var existingInput = form.querySelector('input[name="properties[Estimated-Delivery]"]');
        if (existingInput) existingInput.remove();

        //  Only add hidden input if hide_estimated_delivery is false AND date exists
        if (!variant.hide_estimated_delivery && variant.estimated_delivery_date) {
            var hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = "properties[Estimated-Delivery]";
            hiddenInput.value = variant.estimated_delivery_date;
            form.appendChild(hiddenInput);
        }
    }, true); // run before Shopify hijacks submit
} else {
    console.warn("Product form not found at script execution time");
}
